export default __webpack_public_path__ + "static/media/safetyq.f761c0fe.png";